"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSSTitleAnimationOnHover = exports.StyledTitleSpan = exports.StyledTitle = exports.StyledLabel = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var mixins_1 = require("../../../themes/mixins");
var Typo_1 = require("../../../components/Typo");
var utilsOolib_1 = require("../../../utilsOolib");
var themes_1 = require("../../themes");
var Typo2_1 = require("../Typo2");
/** -- this bit is common for CardContent, ListContent and CardEmbed */
var grey80 = themes_1.colors.grey80;
exports.StyledLabel = (0, styled_components_1.default)(Typo_1.LABEL)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", " \n"], ["\n  ", ";\n  ", " \n"
    /** -- END this bit is common for CardContent, ListContent and CardEmbed */
    /** --- this bit handles the entire title underline hover animation --- */
])), mixins_1.ellipsis, function (_a) {
    var disabled = _a.disabled;
    return disabled && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  "], ["\n  color: ", ";\n  "])), themes_1.colors.greyColor40);
});
/** -- END this bit is common for CardContent, ListContent and CardEmbed */
/** --- this bit handles the entire title underline hover animation --- */
exports.StyledTitle = (0, styled_components_1.default)(Typo2_1.UI_BODY_SEMIBOLD)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), grey80);
exports.StyledTitleSpan = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, mixins_1.multilineUnderline)({
        color: (0, utilsOolib_1.getPrimaryColor100)(theme === null || theme === void 0 ? void 0 : theme.colors),
        thickness: '2px',
    }).init;
}, (0, mixins_1.transition)("background-size 0.5s"));
exports.CSSTitleAnimationOnHover = (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n.StyledTitle {\n      color: ", ";\n    }\n\n    .StyledTitleSpan {\n      //animate the underline created by the mixin : underlineForAnimation\n      ", "\n    }\n"], ["\n.StyledTitle {\n      color: ", ";\n    }\n\n    .StyledTitleSpan {\n      //animate the underline created by the mixin : underlineForAnimation\n      ", "\n    }\n"
    /** --- END this bit handles the entire title underline hover animation --- */ ])), function (_a) {
    var theme = _a.theme;
    return (0, utilsOolib_1.getPrimaryColorText)(theme === null || theme === void 0 ? void 0 : theme.colors);
}, function (_a) {
    var theme = _a.theme;
    return (0, mixins_1.multilineUnderline)({
        color: (0, utilsOolib_1.getPrimaryColor100)(theme === null || theme === void 0 ? void 0 : theme.colors),
        thickness: "2px",
    }).hovered;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
/** --- END this bit handles the entire title underline hover animation --- */ 
